module.exports = __webpack_public_path__ + "img/jbar-logo.ee132752.png";